<template>
  <div id="operator">

    <!-- 调用树形下拉框组件 -->
    <SelectTree
      :disabled='disabled'
      :props="props"
      :options="data"
      :value="valueId"
      :clearable="isClearable"
      :accordion="isAccordion"
      @filter-method="handleSearch"
      @getValue="getValue($event)"/>
  </div>
</template>


<style lang="scss">
  .el-select-dropdown[type='fnj']{
    z-index: 3000 !important;
  }

</style>
<script>
    import SelectTree from "../TreeSelect/index";
    import {getCascade} from "@/services/deviceType";
    export default {
        name: "Operator",
        components: {
            SelectTree
        },
        watch:{
            value:{
                immediate:true,
                handler(value){
                    if (value) {
                        this.valueId = value.value;
                    } else {
                        this.valueId =null ;
                    }

                }
            }
        },
        props:{
               disabled:{
                 type: Boolean,
                    default(){
                        return false;
                    }
            },
            type:{
                default(){
                    return undefined;
                }
            },
            value:{}
        },
        data() {
            return {
                data:[],
                oriList:[],
                isClearable:true,      // 可清空（可选）
                isAccordion:true,      // 可收起（可选）
                valueId:20,            // 初始ID（可选）
                props:{                // 配置项（必选）
                    value: 'id',
                    label: 'operatorName',
                    children: 'children',
                    // disabled:true
                },
                // 选项列表（必选）
                list:[

                ]
            };
        },
        computed:{

            /* 转树形数据 */
            optionData(){
                let cloneData = JSON.parse(JSON.stringify(this.list))      // 对源数据深度克隆

                console.log(data);
                return data;
            }
        },
        methods:{
            handleSearch(data){
                this.data= this.oriData.filter(item=>{
                    return item.operatorName.indexOf(data)!=-1;
                })
            },
            // 取值
            getValue(value){
                this.valueId = value
                let find = this.operator.find((item, i) => {
                    return item.value == value
                })
                if (!find) {
                    find = {};
                }

                if (find==undefined) {
                    find = "";
                }
                this.$emit("input", {...find});
                this.$emit("change", {...find});
                // this.data = {...find};
            },



            getOperatorIds(list){
                let result=[];
                for (let i = 0; i < list.length; i++) {
                    result.push(list[i].id);
                    if(list[i].children){
                        let ids=  this.getOperatorIds(list[i].children);
                        if(ids){
                            result=[...result,...ids];
                        }
                    }
                }
                return  result;
            },


            getSurplusItem(ids,list){
                return list.filter(item=>{
                    return !ids.find(item2=>{
                        return item2==item.id;
                    });
                });
            },

            getIdentify(value){
              let find=  this.oriList.find(item=>{
                    return item.id==value;
                });
              if(find){
                  return find.identify;
              }
              return  "";
            },
            async loadData() {
                const response = await getCascade({type:this.type});
                this.oriList=[];
                if (response) {

                    let list=[... response.data.operatorName];
                    this.oriList=list;
                    let totalData=[]
                    while(list.length>0) {
                        let operator =list.sort((a,b)=>{
                            return a.level.localeCompare(b.level)
                        });
                        let data=  operator.filter(father=>{                      // 循环所有项，并添加children属性
                            let branchArr = operator.filter(child=>father.id == child.parentId);       // 返回每一项的子级数组
                            branchArr.length>0 ? father.children=branchArr : ''   //给父级添加一个children属性，并赋值
                            return father.level==operator[0].level;      //返回第一层
                        });
                        totalData=[...totalData,...data];

                        let ids= this.getOperatorIds(data);
                        list = this.getSurplusItem(ids,list);
                    }



                    this.data=totalData;
                    this.oriData=totalData;
                    this.operator=response.data.operatorName.map((item, i) => {
                        return {name: item.operatorName, value: item.id}
                    });

                }
                this.$emit("init");
            },
        },
        created() {
            this.loadData();
        }
    };
</script>

<style>
  /*#app {*/
  /*  font-family: "Avenir", Helvetica, Arial, sans-serif;*/
  /*  -webkit-font-smoothing: antialiased;*/
  /*  -moz-osx-font-smoothing: grayscale;*/
  /*  text-align: center;*/
  /*  color: #2c3e50;*/
  /*  margin-top: 60px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/operation/Operator.vue